<template>
    <el-dialog title="港杂费配置" :visible="visible" :show="show" width="40%"     :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="150px">
            <el-form-item label="港口名称" class="input" prop="name">
                <!--<el-input-number :controls="false" v-model="ruleForm.name" :step="0.1" autocomplete="off"
                                 placeholder="请输入煤炭价格税点" style="width:90%"></el-input-number>-->
                <el-select v-model="ruleForm.name" style="width:90%">
                    <el-option v-for="(item,i) in portList"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="港杂费价格" class="input" prop="price">
                <el-input-number :controls="false" v-model="ruleForm.price" autocomplete="off"
                                 placeholder="请输入港杂费价格" style="width:90%"></el-input-number>
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'portAddOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.role = this.$storage.get("role");
                }
            },
            rowData(){
                this.ruleForm = this.rowData;
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
        },
        data(){
            return{
                portList:[],
                updateBtn:true,
                url:base.get().url,
                visible:false,
                ruleForm:{
                    name:'',
                    price:'',
                },
                role:'',
                rules:{
                    name:[{ required: true, message: '请选择港口名称', trigger: 'blur' }],
                    price:[{ required: true, message: '请输入港杂费', trigger: 'blur' }],
                },
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`basePriceConfig/`+"savePortConfig":this.url+`basePriceConfig/`+"updatePortConfig",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: data.msg,
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            initPortList(){

            }
        }
    }
</script>
<style lang="scss">
    .module-dialog .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }
    .module-dialog .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }
    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
    }
    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }
</style>